import OuterCard from "./OuterCard";

export default OuterCard